<template>
    <rkm-area
        type="fieldset"
        title="Informações Adicionais"
    >
        <rkm-row v-if="data.model">

            <rkm-col cols="6">

                <rkm-form-select
                    :options="data.form.escalaCoelho"
                    label="Escala de coelho"
                    show-default-option
                    text-field="descricao"
                    v-model="data.model.informacao.escalaCoelhoId"
                    default-option-text="Selecione"
                    value-field="id"
                    class="pt-0"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.higieneResidencial"
                    textField="descricao"
                    valueField="id"
                    label="Higiene residencial"
                    v-model="data.model.informacao.higieneResidencialId"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-radio-group
                    v-model="data.model.informacao.bolsaFamilia"
                    label="Bolsa família"
                    class="pt-0"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-radio-group
                    v-model="data.model.informacao.valeGas"
                    label="Vale gás"
                    class="pt-0"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-radio-group
                    v-model="data.model.informacao.bolsaEscola"
                    label="Bolsa escola"
                    class="pt-0"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox-group
                    :options="data.form.lazer"
                    label="Lazer"
                    class="mx-2"
                    name="lazer"
                    text-field="descricao"
                    v-model="data.model.informacao.lazer"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-radio-group
                    v-model="data.model.informacao.bpc"
                    label="BPC"
                    class="pt-0"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>

export default {
    props: {
        data: { type: Object, required: false, },
    }
}
</script>